'use client';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  padding: ${({ theme }) => theme.spacing(4)};
  background: ${props => props.theme.colors.get(props.backgroundColor)};
`;

export const HeaderContainer = styled.div`
  text-align: center;
`;

export const Heading = styled.h3`
  ${({ theme }) => theme.typography.subheading1};
  padding: ${({ theme }) => theme.spacing(1)};
`;

export const SubHeading = styled.h4`
  ${({ theme }) => theme.typography.heading5};
  padding: ${({ theme }) => theme.spacing(1, 0, 2)};
`;

export const ButtonSection = styled.div`
  text-align: center;
  margin: ${({ theme }) => theme.spacing(2, 0)};
`;
